import React, { Component } from 'react';
import { Switch, Route, Redirect, BrowserRouter as Router, useLocation } from 'react-router-dom';
import DynamicRouteWrapper from './components/DynamicRouteWrapper'
import HomePage from './containers/HomePage'
import OfferPage from './containers/OfferPage'
import ServicesPage from './containers/ServicesPage'
import ServicesPage2_1 from './containers/ServicesPage2_1'
import ServicesPage2_1_1 from './containers/ServicesPage2_1_1';
import ServicesPage2_1_2 from './containers/ServicesPage2_1_2';
import ServicesPage2_1_3 from './containers/ServicesPage2_1_3';
import ServicesPage2_1_4 from './containers/ServicesPage2_1_4';
import ServicesPage2_1_6 from './containers/ServicesPage2_1_6';
import ServicesPage2_2 from './containers/ServicesPage2_2';
import ServicesPage2_2_1 from './containers/ServicesPage2_2_1';
import ServicesPage2_2_2 from './containers/ServicesPage2_2_2';
import ServicesPage2_2_3 from './containers/ServicesPage2_2_3';
import ServicesPage2_2_4 from './containers/ServicesPage2_2_4';
import ServicesPage2_2_6 from './containers/ServicesPage2_2_6';
import ServicesPage2_3 from './containers/ServicesPage2_3';
import ServicesPage2_3_1 from './containers/ServicesPage2_3_1';
import ServicesPage2_3_2 from './containers/ServicesPage2_3_2';
import ServicesPage2_3_3 from './containers/ServicesPage2_3_3';
import ServicesPage2_3_4 from './containers/ServicesPage2_3_4';
import ServicesPage2_3_5 from './containers/ServicesPage2_3_5';
import ServicesPage2_3_6 from './containers/ServicesPage2_3_6';
import ServicesPage2_3_7 from './containers/ServicesPage2_3_7';
import ServicesPage2_4 from './containers/ServicesPage2_4';
import ContactPage from './containers/ContactPage'
import ReferencesPage from './containers/ReferencesPage'
import EmployeePage from './containers/EmployeePage'

import OpenApplicationPage from './containers/OpenApplicationPage'
import JobApplicationPage from './containers/JobApplicationPage'
import OpenJobsPage from './containers/OpenJobsPage'
import RecruitmentListPage from './containers/RecruitmentListPage'

import GDPRPage from './containers/GDPRPage'

import BlogIndexPage from './containers/BlogIndexPage'
import BlogPostPage from './containers/BlogPostPage'

import CourseDetailPage from './containers/CourseDetailPage'
import CoursePaymentAcceptPage from './containers/CoursePaymentAcceptPage'
import CoursePaymentCancelPage from './containers/CoursePaymentCancelPage'

import NotFoundPage from './containers/NotFoundPage'
import  Header from './components/Header';
import  Footer from './components/Footer';
import './App.scss';
import fb from './facebook.jpg'
import {Helmet} from 'react-helmet'
import { SITE_URL } from './components/PageMeta';


import ScrollToTop from './ScrollToTop';

const SITE_DESCRIPTION = 'Tarjoamme turvallisuusalan palveluita yrityksille, yksityishenkilöille, yhteisöille sekä julkiselle sektorille. Palvelemme asiakkaitamme 32 paikkakunnalla ympäri Suomen reilun 1000 henkilön voimin.';

// CRA emits root-relative asset paths; social scrapers need absolute URLs.
const absoluteUrl = (path) => (/^https?:\/\//.test(path) ? path : `${SITE_URL}${path.startsWith('/') ? '' : '/'}${path}`);

const OFFICE = (name, street, postalCode, city, extra) => ({
  '@type': 'LocalBusiness',
  '@id': `${SITE_URL}/yhteystiedot#${city.toLowerCase()}`,
  name: `Nordic Security Alliance ${name}`,
  parentOrganization: { '@id': `${SITE_URL}/#organization` },
  image: `${SITE_URL}/nsa-logo.png`,
  url: `${SITE_URL}/yhteystiedot`,
  email: 'toimisto@nordicsec.fi',
  address: {
    '@type': 'PostalAddress',
    streetAddress: extra ? `${extra}, ${street}` : street,
    postalCode,
    addressLocality: city,
    addressCountry: 'FI'
  }
});

const ORGANIZATION_JSON_LD = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: 'Nordic Security Alliance',
      legalName: 'Nordic Security Alliance Group Oy',
      alternateName: 'NSA',
      url: `${SITE_URL}/`,
      logo: `${SITE_URL}/nsa-logo.png`,
      description: SITE_DESCRIPTION,
      email: 'toimisto@nordicsec.fi',
      vatID: 'FI28401535',
      taxID: '2840153-5',
      areaServed: { '@type': 'Country', name: 'Finland' },
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Linnoitustie 6',
        postalCode: '02600',
        addressLocality: 'Espoo',
        addressCountry: 'FI'
      },
      sameAs: [
        'https://www.facebook.com/NordicSec',
        'https://www.instagram.com/nordicsecurityalliance/',
        'https://www.linkedin.com/company/nordicsecurityalliance/'
      ]
    },
    OFFICE('Espoo', 'Linnoitustie 6', '02600', 'Espoo', 'Säterin Portti'),
    OFFICE('Tampere', 'Puutarhakatu 33', '33210', 'Tampere', null),
    OFFICE('Turku', 'Ruissalontie 12 C', '20200', 'Turku', 'Saippua Center')
  ]
};

const AppContent = () => {
  const location = useLocation();
  
  const routes = [
      <Route exact path="/" component={HomePage}/>,
      <Route  path="/tarjouspyynto" component={OfferPage}/>,
      <Redirect from="/tajouspyynto" to="/tarjouspyynto"/>,
      <Route  path="/turvallisuuspalvelut" component={ServicesPage}/>,

      <Route  path="/jarjestyksenvalvonta/ravintolaturvallisuus" component={ServicesPage2_1_1}/>,
      <Route  path="/jarjestyksenvalvonta/tapahtumaturvallisuus" component={ServicesPage2_1_2}/>,
      <Route  path="/jarjestyksenvalvonta/leirintaalue" component={ServicesPage2_1_3}/>,
      <Route  path="/jarjestyksenvalvonta/matkustaja-alus" component={ServicesPage2_1_4}/>,
      <Redirect from="/jarjestyksenvalvonta/joukkoliikennejaliikenneasemat" to="/jarjestyksenvalvonta/joukkoliikenne-ja-liikenneasemat"/>,
      <Route  path="/jarjestyksenvalvonta/kauppakeskus" component={ServicesPage2_1_6}/>,
      <Route  path="/jarjestyksenvalvonta" component={ServicesPage2_1}/>,

      <Route  path="/vartiointi/paikallisvartiointi" component={ServicesPage2_2_1}/>,
      <Route  path="/vartiointi/tyomaajateollisuusvartiointi" component={ServicesPage2_2_2}/>,
      <Route  path="/vartiointi/myymalavartiointi" component={ServicesPage2_2_3}/>,
      <Route  path="/vartiointi/lastensuojelu" component={ServicesPage2_2_4}/>,
      <Redirect from="/vartiointi/aulapalvelut" to="/vartiointi/aula-ja-vastaanottopalvelut"/>,
      <Route  path="/vartiointi/henkilosuojaus" component={ServicesPage2_2_6}/>,
      <Redirect from="/vartiointi/etsiva-ja-rikostenpaljastamistoiminta" to="/vartiointi/etsivapalvelut"/>,
      <Route  path="/vartiointi" component={ServicesPage2_2}/>,

      <Route  path="/asiantuntijapalvelut/tapahtuman-turvallisuus-ja-pelastussuunnitelma" component={ServicesPage2_3_1}/>,
      <Route  path="/asiantuntijapalvelut/ensiapusuunnitelma" component={ServicesPage2_3_2}/>,
      <Route  path="/asiantuntijapalvelut/liikenteenohjaussuunnitelma" component={ServicesPage2_3_3}/>,
      <Route  path="/asiantuntijapalvelut/kiinteiston-pelastussuunnitelma" component={ServicesPage2_3_4}/>,
      <Route  path="/asiantuntijapalvelut/turvallisuusvalvoja" component={ServicesPage2_3_6}/>,
      <Route  path="/asiantuntijapalvelut/turvallisuuspaallikko" component={ServicesPage2_3_5}/>,
      <Route  path="/asiantuntijapalvelut/hse-valvoja" component={ServicesPage2_3_7}/>,
      <Route  path="/asiantuntijapalvelut" component={ServicesPage2_3}/>,

      <Route  path="/muutpalvelut/vaatesailytys"><Redirect to="/muutpalvelut#vaatesailytys"/></Route>,
      <Route  path="/muutpalvelut/radiopuhelin"><Redirect to="/muutpalvelut#radiopuhelin"/></Route>,
      <Route  path="/muutpalvelut/ensiapu"><Redirect to="/muutpalvelut#ensiapu"/></Route>,
      <Route  path="/muutpalvelut/defibrillaattori"><Redirect to="/muutpalvelut#defibrillaattori"/></Route>,
      <Route  path="/muutpalvelut/liikenteenohjaus"><Redirect to="/muutpalvelut#liikenteenohjaus"/></Route>,
      <Route  path="/muutpalvelut/alkometrit"><Redirect to="/muutpalvelut#alkometrit"/></Route>,
      <Route  path="/muutpalvelut/turvatekniikka"><Redirect to="/muutpalvelut#turvatekniikka"/></Route>,
      <Route  path="/muutpalvelut" component={ServicesPage2_4} />,

      <Route  path="/referenssit" component={ReferencesPage}/>,
      <Route  path="/yhteystiedot" component={ContactPage}/>,

      <Route  path="/tyonhakijalle/avoimettyopaikat" component={OpenJobsPage}/>,
      <Route  path="/tyonhakijalle/liityrekrylistalle" component={RecruitmentListPage}/>,
      <Route  path="/tyonhakijalle/avoinhakemus" component={OpenApplicationPage}/>,
      <Route  path="/tyonhakijalle/tyo/:id" component={JobApplicationPage}/>,
      <Route  path="/tyonhakijalle" component={EmployeePage}/>,

      /* tietosuojaseloste is now a dynamic CMS page */

      <Route  path="/koulutus/maksu/onnistui" component={CoursePaymentAcceptPage}/>,
      <Route  path="/koulutus/maksu/peruutettu" component={CoursePaymentCancelPage}/>,
      <Route  path="/koulutus/:slug" component={CourseDetailPage}/>,

      <Route  path="/blogi/:slug" component={BlogPostPage}/>,
      <Route  path="/blogi" component={BlogIndexPage}/>,

      <Route  component={NotFoundPage}/>
    ];

    return (
      <div className="App" id="App">
      <Helmet>
            <title>Nordic Security Alliance</title>
            <meta name="description" content={SITE_DESCRIPTION} />
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="fi_FI" />
            <meta property="og:title" content="Nordic Security Alliance" />
            <meta property="og:site_name" content="Nordic Security Alliance"/>
            <meta property="og:url" content={`${SITE_URL}${location.pathname}`} />
            <meta property="og:description" content={SITE_DESCRIPTION} />
            <meta property="og:image" content={absoluteUrl(fb)} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta name="twitter:card" content="summary_large_image" />
            <link rel="canonical" href={`${SITE_URL}${location.pathname}`} />
            <script type="application/ld+json">{JSON.stringify(ORGANIZATION_JSON_LD)}</script>
        </Helmet>
        <ScrollToTop />
        <Header />
        <main id="main">
          <DynamicRouteWrapper routes={routes}>
          </DynamicRouteWrapper>
        </main>

        <Footer />
      
      </div>
    );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
